// On slide change, pause all videos
$('.shopify-product-gallery').on('beforeChange', function(event, slick, currentSlide, nextSlide){
  $('video').each(function() {
    $(this).get(0).pause();
  });
  $('.youtube-vid iframe').each(function(){
    $(this).attr('src', ' ');
  });
});

// On slide chnage, play a video inside the current slide
$('.shopify-product-gallery').on('afterChange', function(event, slick, currentSlide, nextSlide){
  if( $('.single-product-thumbnail .slick-current').find('video').length !== 0) {
    $('.product-image-summary .nt-show-product-gallery-wrap').hide();
    $(".shopify-product-gallery .slick-current video")[0].play();
  }
  if( $('.single-product-thumbnail .slick-current').find('iframe').length !== 0) {
    $('.product-image-summary .nt-show-product-gallery-wrap').hide();
    $url = $('.slick-current .youtube-vid').data('src');
    $('.slick-current iframe').attr('src', $url);
  }
  if($('.single-product-thumbnail .slick-current').find('model-viewer').length !== 0) {
    $('.product-image-summary .nt-show-product-gallery-wrap').hide();
  }
  if($('.single-product-thumbnail .slick-current').find('img').length !== 0) {
    $('.product-image-summary .nt-show-product-gallery-wrap').show();
  }
});

$(document).ready(function() {
    // Target specific elements that may contain the word
    $('body.template-collection .filter-content li a').each(function() {
      var text = $(this).html();
      // Replace any uppercase instances of 'iTero' and wrap them in a span
      text = text.replace(/\b[iI][Tt]ero\b/g, '<p class="brand">iTero</p>');
      $(this).html(text);
    });
});